define('entities/mails',[
  'app',
  'jquery',
  'backbone',
  'underscore',
  'settings',
  'backboneRelational'
], function (
  App,
  $,
  Backbone,
  _,
  Settings
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = {ns: Backbone.Relational.store._modelScopes[0]};
  } else {
    app = {ns: {}};
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.Mail = Backbone.Model.extend({
    idAttribute: 'id',

    getAddress: function () {
      var address = '';

      if (this.get('from') && this.get('from').length > 0) {
        address = this.get('from')[0].address;
      }

      return address;
    },

    getName: function () {
      var name = '';

      if (this.get('from') && this.get('from').length > 0) {
        if (this.get('from')[0].personal)
          name = this.get('from')[0].personal;

        if (name === '')
          name = this.get('from')[0].address;
      }

      return name;
    },

    addLabel: function (fromSecId, folder, label) {
      var defer = $.Deferred();
      var folderName = folder ? folder.fullName : '';

      var url = Settings.url('compuzz2', 'mails/addLabel/' +
          fromSecId + '/' +
          this.get('id') +
          '/labels?label=' +
          encodeURIComponent(label.id)) + '&folder=' + encodeURIComponent(folderName);

      $.ajax({
        method: 'POST',
        url: url,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        },
        complete: function (response) {
          defer.resolve(response);
        }
      });
      return defer.promise();

    },

    removeLabel: function (fromSecId, label) {
      var defer = $.Deferred();
      var url = Settings.url('compuzz2', 'mails/addLabel/' +
        fromSecId + '/' +
        this.get('id') +
        '/labels?label=' + encodeURIComponent(label.id || label.name));

      $.ajax({
        method: 'DELETE',
        url: url,
        contentType: 'application/json',
        success: function (response) {
          defer.resolve(response);
        },
        error: function () {
          defer.reject();
        },
        complete: function (response) {
          defer.resolve(response);
        }
      });
      return defer.promise();
    },

    getDowloadUrl: function (fromSecId, fileName) {
      var params = {
        folder: encodeURIComponent(this.get('folder')?this.get('folder').fullName:'')
      };

      return Settings.url('compuzz2', 'mails/fetch/' +
        fromSecId + '/' +
        this.get('id') +
        '/download/' + encodeURIComponent(fileName), params);
    }
  });


  var API = {
    fromMail: [],

    getFoldersUrl: function (secId, params) {
      return Settings.url('compuzz2', 'mails/fetchFolders/' + secId, params);
    },

    getUrl: function (secId, params) {
      return Settings.url('compuzz2', 'mails/fetch/' + secId, params);
    },

    getMailUrl: function (secId, folder, mailId) {
      var params = {};
      params.folder = encodeURIComponent(folder);

      return Settings.url('compuzz2', 'mails/fetch/' + secId + '/' + mailId, params);
    },
    getCustomerMailsUrl: function (customerSecId, params) {
      return Settings.url('compuzz2', 'mails/fetch/customer/' + customerSecId, params);
    },

    getFromMails: function () {
      var defer = $.Deferred();
      
      if (API.fromMail.length > 0)
        defer.resolve(API.fromMail);
      else {
        $.ajax({
          type: 'GET',
          url: Settings.url('compuzz2', 'v2/userpid/emailAddresses'),
          contentType: 'application/json',
          success: function (mails) {
            API.fromMail = mails;
            defer.resolve(mails);
          }
        });
      }      

      return defer.promise();
    },  

    sendMail: function (userSecId, to, cc, bcc, subject, message, attachments, purchaseOrderIds) {
      var defer = $.Deferred();
     
      var data = {
        fromSecId: userSecId,
        to: to,
        cc: cc,
        bcc: bcc,
        subject: subject,
        message: message,
        attachments: attachments,
        purchaseOrderIds: purchaseOrderIds
      };

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'mails/send'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        success: function () {
          defer.resolve();
        },
        error: function () {
          defer.reject();
        }
      });     

      return defer.promise();
    }
  };

  App.reqres.setHandler('mails:model', function (data) {
    var tt;
    if (data) {
      tt = Backbone.Relational.store.find(app.ns.Mail, data.id);
    }
    if (tt) {
      return tt;
    } else {
      return new app.ns.Mail(data);
    }
  });

  App.reqres.setHandler('mails:getFromMails', function () {
    return API.getFromMails();
  });

  App.reqres.setHandler('mails:send', function (userSecId, to, cc, bcc, subject, message, attachments, purchaseOrderIds ) {
    return API.sendMail(userSecId, to, cc, bcc, subject, message, attachments, purchaseOrderIds);
  });

  App.reqres.setHandler('mails:get-folders-url', function (secId, params) {
    return API.getFoldersUrl(secId, params);
  });

  App.reqres.setHandler('mails:row-count-url', function (secId) {
    return API.getRowCountUrl(secId);
  });

  App.reqres.setHandler('mails:get-url', function (secId, params) {
    return API.getUrl(secId, params);
  });

  App.reqres.setHandler('mails:get-customer-all-mails-url', function (customerSecId, params) {
    return API.getCustomerMailsUrl(customerSecId, params);
  });

  App.reqres.setHandler('mails:get-mail-url', function (secId, folder, mailId) {
    return API.getMailUrl(secId, folder, mailId);
  });
});
